{
    "Accessibility Menu": "Меню за достъпност",
    "Reset settings": "Нулиране на настройките",
    "Close": "Затвори",
    "Content Adjustments": "Настройки на съдържанието",
    "Adjust Font Size": "Настройка на размера на шрифта",
    "Highlight Title": "Открояване на заглавието",
    "Highlight Links": "Открояване на връзките",
    "Readable Font": "Четим шрифт",
    "Color Adjustments": "Настройки на цветовете",
    "Dark Contrast": "Тъмен контраст",
    "Light Contrast": "Светъл контраст",
    "High Contrast": "Висок контраст",
    "High Saturation": "Висока наситеност",
    "Low Saturation": "Ниска наситеност",
    "Monochrome": "Монохромен",
    "Tools": "Инструменти",
    "Reading Guide": "Ръководство за четене",
    "Stop Animations": "Спри анимациите",
    "Big Cursor": "Голям курсор",
    "Increase Font Size": "Увеличи размера на шрифта",
    "Decrease Font Size": "Намали размера на шрифта",
    "Letter Spacing": "Разстояние между буквите",
    "Line Height": "Височина на реда",
    "Font Weight": "Дебелина на шрифта",
    "Dyslexia Font": "Шрифт за дислексия",
    "Language": "Език",
    "Open Accessibility Menu": "Отвори меню за достъпност"
  }
  